import styled from 'styled-components';
import colors from '../../includes/colors';

export const ChatContainer = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  transition: all 0.3s;

  .chat-live-with-rep {
    border: none;
    background: none;
    color: ${colors.blue};
    padding: 0;
  }

  @media (min-width: 576px) {
    margin-left: 0;
    left: auto;
    top: 40%;
    right: -260px;
    &.active-md {
      right: -1px;
    }
  }

  .dfs-chat__trigger {
    box-shadow: 2px -2px 4px 0 rgba(0, 0, 0, 0.3);
    border: 1px solid #fff;
    left: 15px;
    background-color: ${colors.blue};
    color: #fff;
    width: fit-content;
    position: absolute;
    bottom: 0;
    transition: all 0.3s;
    z-index: 1;

    @media (min-width: 576px) {
      transform: rotate(-270deg);
      position: absolute;
      transform-origin: left top;
      margin-bottom: 0;
      transition: none;
      top: 0px;
      height: fit-content;
      max-height: 26px;
      border: none;
      left: 0px;
      width: fit-content;
    }

    .dds__icons {
      font-size: 21px;
      position: relative;
      top: 4px;
    }

    button {
      color: #fff;
      background-color: ${colors.blue};
      border: none;
      outline: none;

      &:focus,&:focus:active {
        background-color: ${colors.darkBlue};
      }
    }

    .dds-chat__action-text--mobile {
      @media (min-width: 576px) {
        display: none;
      }
    }

    .dds-chat__action-text {

      display: none;
      transform: rotate(-180deg);

      @media (min-width: 576px) {
        display: inline;
      }
    }

    .dds__icons__offline-button {
      display: none;
    }

    .dfs-chat__options a:hover {
      color: ${colors.blue};
    }
  }

  .dfs-chat__content {
    background-color: #fff;
    border-width: 1px;
    border-style: solid;
    border-color: #a9a9a9;
    padding: 20px 20px 0 20px;
    position: relative;
    border-left: 3px solid #007db8;
    border-top: 3px solid #007db8;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);
    width: 260px;
    left: 15px;
    bottom: -200px;
    transition: all 0.3s;
    z-index: 2;
    position: absolute;

    @media (min-width: 576px) {
      left: 0;
      bottom: 0;
      position: relative;
    }

    &.active {
      bottom: 0;
      position: relative;
    }

    .dfs-chat__options {
      list-style: none;
      padding: 0;

      li {
        font-size: 13px;
        display: flex;
        color: ${colors.blue};
        align-items: center;
        margin-bottom: 11px;
        cursor: pointer;

        span {
          outline: none;
        }
      }
    }

    .dfs-chat__content-header {
      color: #444;
      font-size: 15px;
    }
  }
`;

export const CloseButton = styled.span`
  font-size: 20px;
  background-color: transparent;
  color: #444;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 10px;
  cursor: pointer;
`;
